module.exports = __webpack_public_path__ + "static/media/leadership-mob.d2675f08.png";